import { atom } from 'recoil'

export type PlayingVideoState = {
	videoIdx: string | null
}

export const playingVideoState = atom<PlayingVideoState>({
	key: 'playingVideoState',
	default: {
		videoIdx: null,
	},
})
